module.exports = __webpack_public_path__ + "img/collaborate_28.bc249ec8.jpg";